<template>
  <div class="side-panel-right-field">
    <div class="mb-8">
      Сканы или фотографии паспортов владельцев и руководителя компании могут быть цветными или черно-белыми, но на них
      должны отчетливо читаться все данные.
    </div>
    <ul class="mb-5">
      <li v-for="fl in fls" :key="fl.id">
        <h3 class="font font--h3 mb-2">{{ fl.name }}</h3>
        <UploadSection :oid="fl.id" :files="fl.files" @attachment-file-add="addFile" @file-delete="deleteFile" />
      </li>
    </ul>
    <v-btn class="primary mb-8">Отправить</v-btn>
  </div>
</template>

<script>
import { getBid } from "@/api/bids";
import UploadSection from "@/components/bids/UploadSection";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("bid", ["bidId"]),
    fls() {
      const details = this.$store.state.bid.details;
      return details ? details.fls : [];
    },
  },
  methods: {
    async addFile() {
      //TODO: проверить!!!
      const response = await getBid(this.bidId);
      if (response) {
        this.$store.commit("bid/setBidDetails", response);
      }
    },
    async deleteFile() {
      //TODO: проверить!!!
      const response = await getBid(this.bidId);
      if (response) {
        this.$store.commit("bid/setBidDetails", response);
      }
    },
  },
  components: {
    UploadSection
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.note {
  padding: 14px 20px;
  background: #fcf2ce;
  border-radius: 3px;
  margin-bottom: 16px;
  .font--color_warning {
    color: #d2aa0f;
  }
}
.bid-details {
  background-color: #f5f5f6;
  & > div > div:first-child {
    flex-basis: 200px;
  }
}
</style>
